import { EmbeddedPodlet } from "@mobility-item-page/client";
import type { MobilityAd } from "@mobility-item-page/types";
import { useAdViewMeta } from "../../context/AdViewProviderContext.tsx";
import { useAppConfig } from "../../context/AppConfigProviderContext.tsx";
import { usePodlets } from "../podlets.ts";
import ContactAdvertiser from "./ContactAdvertiser.tsx";
import { InactiveAlert } from "./InactiveAlert.tsx";

export const PrivateSeller = ({ adviewtype }: { adviewtype: MobilityAd["adViewType"] }) => {
  const { isPreview } = useAppConfig();
  const { mode } = useAdViewMeta();
  const { smoothTrade, adProfileCard } = usePodlets();

  const isInactive = mode !== "PLAY" && !isPreview;
  const hasSmoothTrade = !!smoothTrade && !!smoothTrade.content;

  if (isInactive) {
    return (
      <>
        <InactiveAlert />
        <EmbeddedPodlet className="p-16 border-2 rounded-8 mt-16" response={adProfileCard} />
      </>
    );
  }

  return (
    <>
      {hasSmoothTrade && (
        <EmbeddedPodlet className="mt-40 md:mt-0" response={smoothTrade} cautiouslyReloadScriptOnHydrationError />
      )}
      {!hasSmoothTrade && <ContactAdvertiser adViewType={adviewtype} className="mt-40 md:mt-0" />}
      <EmbeddedPodlet className="p-16 border-2 rounded-8 mt-16" response={adProfileCard} />
    </>
  );
};
